<template>
  <panel-main-template>
    <template v-slot:page-title>Расписание</template>
    <template v-slot:page-content>
      <schedule-calendar :staff="staffList"></schedule-calendar>
    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src

import PanelMainTemplate from "../../components/panel/MainTemplate";
import ScheduleCalendar from "../../components/panel/schedule/ScheduleCalendar";
import staffRepository from "../../repositories/staff";

export default {
  name: "Schedule",
  components: {
    ScheduleCalendar,
    PanelMainTemplate
  },
  data() {
    return {
      staffList: []
    };
  },
  metaInfo: {
    title: "Расписание - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  watch: {},
  computed: {},
  methods: {
    getStaff(){
      staffRepository.getStaff().then(resp => {
        this.staffList = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      })
    }
  },
  created() {
    this.getStaff();
  },
};
</script>

<style scoped lang="less"></style>
